export enum SearchInputTemplateEnum {
  ADD = 1
}
